import { render, staticRenderFns } from "./TransactionWireless.vue?vue&type=template&id=d9804372&scoped=true"
import script from "./TransactionWireless.vue?vue&type=script&lang=js"
export * from "./TransactionWireless.vue?vue&type=script&lang=js"
import style0 from "./TransactionWireless.vue?vue&type=style&index=0&id=d9804372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9804372",
  null
  
)

export default component.exports